const TTL_SECONDS = 24 * 60 * 60

class MemoryCache {
    constructor() {
        this.cache = new Map()
    }

    get(key) {
        const entry = this.cache.get(key)
        if (!entry) return null
        if (Date.now() > entry.expiresAt) {
            this.cache.delete(key)
            return null
        }
        return entry.data
    }

    set(key, data, ttlSeconds = TTL_SECONDS) {
        this.cache.set(key, {
            data,
            expiresAt: Date.now() + ttlSeconds * 1000
        })
    }

    has(key) {
        return this.get(key) !== null
    }

    delete(key) {
        this.cache.delete(key)
    }
}

export default new MemoryCache()
